import React, { Component } from 'react';
import { Button, Label } from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            feed: null,
            affids: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(this.state.feed, this.state.affids);
    }

    render() {
        const affids = this.state.affids.split(',').map(affid => <Label style={{marginRight: '3px'}}>{affid}</Label>);

        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <FieldGroup
                        name="feed"
                        label="Feed:"
                        onChange={this.handleFieldChange}
                        value={this.state.feed}
                    />
                    <FieldGroup
                        name="affids"
                        label="Affids:"
                        onChange={this.handleFieldChange}
                        value={this.state.affids}
                        required
                    />
                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>

                    <div>
                        {affids}
                    </div>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesBlock/components/Form/index.js